<template>
  <van-list
    v-model="loading"
    :finished="finished"
    :finished-text="page.totalCount ? '没有更多了' : ''"
    @load="handleLoad"
  >
    <template v-if="page.totalCount !== 0">
      <slot />
    </template>
    <van-empty v-else description="暂无数据" />
  </van-list>
</template>

<script>
export default {
  name: 'List',
  props: {
    page: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {
    page: {
      handler() {
        this.loading = false;
      },
      deep: true
    }
  },
  computed: {
    finished() {
      const { totalCount, currentPage, currentCount } = this.page;
      return totalCount <= currentPage * currentCount;
    }
  },
  methods: {
    handleLoad() {
      console.log('load');
      this.$emit('requestList');
    }
  }
}
</script>
